import React, { Fragment } from "react";

export default props => {
  const { projectsItems } = props;
  const projectList = projectsItems.map(projectsItem => {
    return (
      <div className="projects__card" key={projectsItem.id}>
        <img
          src={projectsItem.img}
          alt={projectsItem.title}
          className="projects__card-img"
        />
        <h2 className="projects__card-heading">
          <i className="fas fa-angle-right" /> {projectsItem.title}
        </h2>
        <p className="projects__card-description text-white">
          {projectsItem.description}
        </p>

        {projectsItem.link && (
          <a
            href={projectsItem.link}
            target="_blank"
            className="projects__card-btn"
          >
            + See more
          </a>
        )}

        <a
          href={projectsItem.githublink}
          target="_blank"
          className="projects__card-btn2"
        >
          github
        </a>
      </div>
    );
  });
  return <Fragment>{projectList}</Fragment>;
};



// WEBPACK FOOTER //
// ./src/components/ProjectsItem.js